import React, { useContext, useEffect } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import logo from "../assets/images/Logo-Usakti.png";
import { useForm } from "react-hook-form";
import { Message } from "primereact/message";
import { API_URL } from "../utils/const";
import Cookies from "js-cookie";
import { useAuth } from "../Context/AuthContext";
import { useToast } from "../Context/ToastContext";
import { TitleContext } from "../Context/TitleContext";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

const Login = () => {
  
  const isAuthorized = Cookies.get("token");
  const location = useLocation();
  const { toastObj, setToastObj } = useToast();
  const { login } = useAuth();
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("USAKTI | Login"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    if (toastObj.type === "success") {
      toast.success(toastObj.msg);
      setToastObj({ msg: null, type: null });
    } else if (toastObj.type === "danger") {
      toast.error(toastObj.msg);
      setToastObj({ msg: null, type: null });
    }
  }, [toastObj]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  if (isAuthorized && location.pathname == "/login") {
    return <Navigate to="/akademik/course-sessions/all" />;
  }

  const submit = async (formData) => {
    const { email, password } = formData;
    try {
      const response = await axios.post(
        `${API_URL}/login`,
        {
          email,
          password,
        },
        {
          withCredentials: true,
        }
      );
      localStorage.setItem("roles", response.data.roles[0]);

      if (response.data.accessToken) {
        const token = response.data.accessToken;
        const roles = response.data.roles;
        login(token, roles);
      }
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      toast.error(errorMessage)
    }
  };

  return (
    <div className="login-page">
      <Toaster position="top-right" />
      <div className="bg-overlay h-100">
        <div className="container-fluid h-100">
          <div
            className="row justify-content-end h-100"
            style={{ alignItems: "center", fontSize: "0.9rem" }}
          >
            <div className="col-lg-5">
              <div
                className="card shadow-lg"
                style={{
                  borderRadius: "3%",
                  paddingTop: "20px",
                  paddingBottom: "120px",
                }}
              >
                <div className="card-body">
                  <div className="header-auth d-flex mx-4 gap-3">
                    <img src={logo} alt="Usakti" height="100" />
                    <h1>Portal Presensi</h1>
                  </div>
                  <form onSubmit={handleSubmit(submit)}>
                    <div className="row mt-4">
                      <div className="col-md-12 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-label fw-semibold">
                            Email Address
                          </label>
                          <input
                            {...register("email", {
                              required: "Email tidak boleh kosong!",
                              minLength: {
                                value: 2,
                                message: "Email minimal 2 karakter",
                              },
                              maxLength: {
                                value: 60,
                                message: "Email maximal 60 karakter",
                              },
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                message: "Email tidak valid",
                              },
                            })}
                            type="email"
                            className="form-control form-control-sm"
                          />
                          {errors.email && (
                            <Message
                              style={{ fontSize: "smaller" }}
                              className="w-100 mt-1"
                              severity="error"
                              text="Email tidak boleh kosong!"
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-label fw-semibold">
                            Password
                          </label>
                          <input
                            {...register("password", { required: true })}
                            type="password"
                            className="form-control form-control-sm"
                          />
                          {errors.password && (
                            <Message
                              style={{ fontSize: "smaller" }}
                              className="w-100 mt-1"
                              severity="error"
                              text="Password tidak boleh kosong! "
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-md-12 text-end">
                        <Link
                          to="/password/reset"
                          style={{ fontSize: "0.8rem" }}
                        >
                          Forgot Your Password?
                        </Link>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <button className="btn btn-sm rounded btn-primary w-100">
                          MASUK
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
